export const verify_wall_verified_intro = {
  title: "You are verified",
  subtitle: "Your email is confirmed",
  description: "You can continue to the app from here.",
};
